// extracted by mini-css-extract-plugin
module.exports = {"ButtonWrapper":"Button-module--ButtonWrapper--3m0tr"};